'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    ClipboardCheck: ()=>ClipboardCheck
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const react_namespaceObject = require("motion/react");
const external_react_namespaceObject = require("react");
const index_cjs_namespaceObject = require("../../../utils/index.cjs");
const external_styles_cjs_namespaceObject = require("../styles.cjs");
const ClipboardCheck = /*#__PURE__*/ (0, external_react_namespaceObject.forwardRef)(({ className, size = 24, animate = false, ...props }, ref)=>{
    const controls = (0, react_namespaceObject.useAnimation)();
    const isControlledRef = (0, external_react_namespaceObject.useRef)(false);
    const checkVariants = (0, external_react_namespaceObject.useMemo)(()=>({
            normal: {
                pathLength: 1,
                opacity: 0,
                transition: {
                    duration: (0, external_styles_cjs_namespaceObject.getTransitionDurationLong)(),
                    ease: (0, external_styles_cjs_namespaceObject.getTransitionEase)()
                }
            },
            animate: {
                pathLength: [
                    0,
                    1
                ],
                opacity: [
                    0,
                    1
                ],
                transition: {
                    duration: (0, external_styles_cjs_namespaceObject.getTransitionDurationLong)(),
                    ease: (0, external_styles_cjs_namespaceObject.getTransitionEase)()
                }
            }
        }), []);
    (0, external_react_namespaceObject.useImperativeHandle)(ref, ()=>{
        isControlledRef.current = true;
        return {
            startAnimation: ()=>controls.start('animate'),
            stopAnimation: ()=>controls.start('normal')
        };
    });
    (0, external_react_namespaceObject.useEffect)(()=>{
        if (animate) controls.start('animate');
        else controls.start('normal');
    }, [
        animate,
        controls
    ]);
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
        className: (0, index_cjs_namespaceObject.cn)(className),
        ...props,
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("svg", {
            role: "img",
            xmlns: "http://www.w3.org/2000/svg",
            width: size,
            height: size,
            fill: "none",
            viewBox: "0 0 24 24",
            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("g", {
                className: "clipboard_check",
                children: [
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("path", {
                        className: "clipboard",
                        fill: "#001833",
                        d: "M5 22c-.55 0-1.02-.2-1.41-.59C3.2 21.02 3 20.55 3 20V6c0-.55.2-1.02.59-1.41C3.98 4.2 4.45 4 5 4h4.18c.18-.58.54-1.06 1.08-1.44.54-.38 1.12-.56 1.75-.56.67 0 1.26.19 1.79.56.53.37.88.85 1.06 1.44h4.15c.55 0 1.02.2 1.41.59.39.39.59.86.59 1.41v14c0 .55-.2 1.02-.59 1.41-.39.39-.86.59-1.41.59H5Zm0-2h14V6h-2v2c0 .28-.1.52-.29.71-.19.19-.43.29-.71.29H8c-.28 0-.52-.1-.71-.29A.973.973 0 0 1 7 8V6H5v14Zm7-14c.28 0 .52-.1.71-.29.19-.19.29-.43.29-.71 0-.28-.1-.52-.29-.71A.973.973 0 0 0 12 4c-.28 0-.52.1-.71.29-.19.19-.29.43-.29.71 0 .28.1.52.29.71.19.19.43.29.71.29Z"
                    }),
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("path", {
                        className: "check",
                        d: "m9 14 2 2 4-4"
                    }),
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(react_namespaceObject.motion.path, {
                        className: "check",
                        animate: controls,
                        initial: "normal",
                        variants: checkVariants,
                        d: "m9 14 2 2 4-4",
                        style: {
                            transformOrigin: 'center'
                        },
                        stroke: "#001833",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            })
        })
    });
});
ClipboardCheck.displayName = 'ClipboardCheck';
exports.ClipboardCheck = __webpack_exports__.ClipboardCheck;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "ClipboardCheck"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
